import axios from '@api'

export default { 
    getReturnType () {
        return axios.get(`api/master/returntype/`)
    },
    getJdeAfeByAfeNo(afeNo) {
        return axios.get(`api/master/jdeafe/${afeNo}`)
    },
    searchAfeNo (afeNo) {
        return axios.get(`api/master/jdeafe/afeno/${afeNo}`)
    },
    getPoByPoNo(poNo) {
        return axios.get(`api/master/po/${poNo}`)
    },
    getItemNoByItemNo(itemNo, poNo) {
        return axios.get(`api/master/itemNo/${itemNo}?poNo=${poNo}`)
    },
    searchInventoryByItemNo (itemNo) {
        return axios.get(`api/master/inventory?itemNo=${itemNo}`)
    },
    searchInventoryByPartNo (partNo) {
        return axios.get(`api/master/inventory?partNo=${partNo}`)
    },
    getItemByPoNoAndLineId(poNo, lineNo) {
        return axios.get(`api/master/po/${poNo}/lineno/${lineNo}`)
    },
    getCompany() {
        return axios.get(`api/master/company/`)
    },
    getField() {
        return axios.get(`api/master/field/`)
    },
    getLocation() {
        return axios.get(`api/master/location/`)
    },
    getLocationMfd() {
        return axios.get(`api/master/locationmfd/`)
    },
    getUser() {
        return axios.get(`api/master/user/`)
    },
    getFieldCompany() {
        return axios.get(`api/master/fieldcompany/`)
    },
    getDepartment() {
        return axios.get(`api/master/department/`)
    },
    getDepartmentMfd() {
        return axios.get(`api/master/departmentmfd/`)
    },
    getStatus() {
        return axios.get(`api/master/status/`)
    },
    getMfdStatus(page) {
        return axios.get(`api/master/mfdstatus?page=${page}`)
    },
    getActiveStatus() {
        return axios.get(`api/master/activestatus/list/`)
    },
    getExchangeRateTop() {
        return axios.get(`api/master/exchangerate/top`)
    },
    getExchangeRate(json) {
        return axios.post(`api/master/exchangerate`, json)
    },
    searchDictionary(text) {
        return axios.get(`api/master/dictionary?word=${text}`)
    },
    getMaterialType() {
        return axios.get(`api/master/materialtype`)
    },
    getProposal() {
        return axios.get(`api/master/proposal`)
    },
    getProposalWithInitialKey(mfdId) {
        return axios.get(`api/master/proposal?mfdId=${mfdId}`)
    },
    getRole () {
        return axios.get(`api/master/role`)
    },
    getBranchPlant (companyNo) {
        return axios.get(`api/master/branchplant/${companyNo}`)
    },
    getBranchPlantByEntity (companyCode, term) {
        return axios.get(`api/master/branchplant/company?companyCode=${companyCode}&term=${term}`)
    },
    getBinLocationByBranchPlant (branchPlant) {
        return axios.get(`api/master/binlocation?branchPlant=${branchPlant}`)
    },
    validateBinLocation (branchPlant, binLocation) {
        return axios.get(`api/master/validatebinlocation?branchPlant=${branchPlant}&binLocation=${binLocation}`)
    },
    getAssignedLocation (branchPlant, keyword) {
        return axios.get(`api/master/assignedlocation?branchPlant=${branchPlant}&keyword=${keyword}`)
    },
    getCountry () {
        return axios.get(`api/master/country`)
    },
    searchJdeWorkOrder(keyword) {
        return axios.get(`api/master/workorder?keyword=${keyword}`)
    },
    getSupplier() {
        return axios.get(`api/master/supplier`)
    },
    getSupplierSearch(jsonSearch) {
        return axios.post(`api/master/supplier/search`, jsonSearch)
    },
    deleteSupplier(SupplierId) {
        return axios.put(`api/master/supplier/delete/${SupplierId}`)
    },
    saveSupplier(json) {
        return axios.post(`api/master/supplier/save`, json)
    },
    getMaterialGroup() {
        return axios.get(`api/master/materialgroup`)
    },
    getWasteContractor () {
        return axios.get('api/master/wastecontractor')
    },
    getWasteContractorList (json) {
        return axios.post(`api/master/wastecontractorlist`, JSON.stringify(json))
    },
    deleteWasteContractor (wasteContractorId) {
    return axios.put(`api/master/wastecontractor/delete/${wasteContractorId}`)
    },
    saveWasteContractor (json) {
    return axios.post(`api/master/wastecontractor/save`, json)
    },
    getRequester() {
        return axios.get(`api/master/getrequester`)
    },
    getProposalList(page) {
        return axios.get(`api/master/proposallist/${page}`)
    },
    deleteProposalById(proposalId, page) {
        return axios.put(`api/master/proposal/delete/${proposalId}/${page}`)
    },
    updateProposal(json, page) {
        return axios.post(`api/master/proposal/update/${page}`, json)
    },
    addProposal() {
        return axios.get(`api/master/proposal/add`)
    },
    getBuyer() {
        return axios.get(`api/master/buyer/`)
    },
    addProposal(page) {
        return axios.get(`api/master/proposal/add/${page}`)
    },
    getModifyType() {
        return axios.get(`api/master/modifytype/`)
    },
    getJdePoDetail(keyword) {
        return axios.get(`api/master/jdepodetail?keyword=${keyword}`)
    },
    getJdePoDetailAccountCode(keyword) {
        return axios.get(`api/master/jdepodetailaccountcode?keyword=${keyword}`)
    },
    getBankAccount() {
        return axios.get(`api/master/bankaccount`)
    },
    getCreateMfdHeader() {
        return axios.get(`api/master/getcreatemfdheader`)
    },
    getAfeCreateMfd(rmrId, keyword) {
        return axios.get(`api/master/getafe/createmfd/${rmrId}?keyword=${keyword}`)
    },
    getJdeViewList(json) {
        return axios.post(`api/master/getjdeviewlist`, json)
    },
    CheckUomValue(keyword) {
        return axios.get(`api/master/checkuom?keyword=${keyword}`)
    },
    validateWoNo(keyword) {
        return axios.get(`api/master/validatewono?keyword=${keyword}`)
    },
    deleteBankAccount(accountId) {
        return axios.put(`api/master/bankaccount/delete/${accountId}`);
    },
    saveBankAccount (json) {
      return axios.post(`api/master/bankaccount/save`, json);
    },
    getstockcontrolleremail() {
        return axios.get(`api/master/getstockcontrolleremail`)
    },
    getMfdInfoAfeNo(term, companyNo) {
        return axios.get(`api/master/mfdinfo/afeno?term=${term}&companyNo=${companyNo}`)
    },
}